import { Dashboard, Driver } from '@apis/index'
import { Button, GridCard, StatusDropdown, Table } from '@components'
import { IGridItem } from '@components/gridCard'
import { StyleColumn } from '@components/styles'
import { Constant, searchHandler } from '@utils'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Fragment } from 'react/jsx-runtime'
import { IDefaultParams } from '../types'
import AdminDriverForm from './form'

const AdminDriverManagement = () => {
  const { data: dashboard } = useSelector(
    (state: any) => state.deliveryDashboard,
  )
  const debounceRef: any = useRef()
  const [visible, setVisible] = useState<boolean>(false)
  const { items: drivers, loading } = useSelector((state: any) => state.drivers)
  const [params, setParams] = useState<IDefaultParams>({
    page: 1,
    limit: 10,
    search: null,
  })
  const fetchDrivers = async (params: IDefaultParams) => {
    await Driver.getAll(params).catch(() => {})
  }
  const fetchDashboard = async () => {
    const params = {
      type: 'driver',
    }
    await Dashboard.getAllDashboardCount('deliveryDashboard', params).catch(
      () => {},
    )
  }

  useEffect(() => {
    fetchDashboard()

    if (!drivers?.length) {
      fetchDrivers(params)
    }
  }, [])
  const items: IGridItem[] = [
    {
      title: 'Total Drivers',
      value: dashboard?.totalDriver || '0',
      Icon: 'userThree',
    },
    {
      title: 'Total Available Drivers',
      value: dashboard?.totalAvailableDriver || '0',
      Icon: 'userThree',
      IconBg: 'greenLight',
    },
    {
      title: 'Total Reserved Drivers',
      value: dashboard?.totalReservedDriver || '0',
      Icon: 'userThree',
      IconBg: 'yellowLight',
    },
    {
      title: 'Total Unavailable Drivers',
      value: dashboard?.totalUnavailableDriver || '0',
      Icon: 'userThree',
      IconBg: 'redLight',
    },
  ]
  const columns = [
    {
      title: 'Name',
      key: 'name',
    },
    {
      title: 'Phone Number',
      key: 'phoneNo',
    },
    {
      title: 'Address',
      key: 'address',
    },
    {
      title: 'Status',
      key: 'status',
      render: (item: any, index: number) => {
        const handleStatusChange = async (newStatus: string) => {
          await Driver.updateStatus({ status: newStatus }, item.id)
            .then(() => {
              fetchDashboard()
            })
            .catch(() => {})
        }
        return (
          <StatusDropdown
            onChange={handleStatusChange}
            options={Constant.driverStatus.map((status) => ({ name: status }))}
            valueAsKey="name"
            titleAsKey="name"
            value={item?.status}
            isLast={index > drivers?.length - 2}
          />
        )
      },
    },
  ]
  const onAdd = () => {
    setVisible(true)
  }
  const onSearch = searchHandler({
    fetchFunction: fetchDrivers,
    paramKey: 'search',
    debounceTime: 600,
    params,
    setParams,
    debounceRef,
  })
  return (
    <Fragment>
      <StyleColumn>
        <GridCard items={items} />
        <Table
          loading={loading}
          tableTitle="Driver List"
          data={drivers}
          columns={columns}
          filter={{
            hasSearch: true,
            hasFilter: true,
            onSearch: onSearch,
            rightComponent: <Button title="Add" onClick={onAdd} />,
          }}
        />
      </StyleColumn>
      <AdminDriverForm visible={visible} setVisible={setVisible} />
    </Fragment>
  )
}

export default AdminDriverManagement
